import React, { useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { ProblemProof } from './components/ProblemProof';
import { FunctionalSpiceGrid } from './components/FunctionalSpiceGrid';
import { UseCases } from './components/UseCases';
import { SubscriptionBox } from './components/SubscriptionBox';
import { FutureRoadmap } from './components/FutureRoadmap';
import { HowItWorks } from './components/HowItWorks';
import { StickyFooter } from './components/StickyFooter';
import { ScrollSpiceExplosions } from './components/ScrollSpiceExplosions';
import { FloatingSocialCapsule } from './components/FloatingSocialCapsule';
import { SocialFooter } from './components/SocialFooter';
export function App() {
  useEffect(() => {
    document.title = 'NeuroSpice | Season with Reason';
  }, []);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <LanguageProvider data-id="element-0" data-mp="3mjzrt22ccy08">
      <div className="w-full min-h-screen bg-white relative" data-id="element-1" data-mp="3mjgczu7zmpqf">
        <Navigation onScrollToSection={scrollToSection} data-id="element-2" data-mp="3rdkisa5iorpx" />
        <ScrollSpiceExplosions data-id="element-3" data-mp="5ot150vj28n" />
        <FloatingSocialCapsule data-id="element-4" data-mp="4wx1t3d72hu" />
        <div className="relative z-10" data-id="element-5" data-mp="56qxrrj5tst">
          <div id="hero" data-id="element-6" data-mp="2zllff2q1qmn9">
            <Hero onScrollToSection={scrollToSection} data-id="element-7" data-mp="2zm4vedw4z0yn" />
          </div>
          <div id="spices" data-id="element-8" data-mp="33m5b01uz1i7a">
            <FunctionalSpiceGrid data-id="element-9" data-mp="33ngf62sbwryx" />
          </div>
          <div id="use-cases" data-id="element-10" data-mp="38lrnua6w0wfk">
            <UseCases data-id="element-11" data-mp="38li7lebna3n2" />
          </div>
          <div id="subscription" data-id="element-12" data-mp="38kgmeh0x00rm">
            <SubscriptionBox data-id="element-13" data-mp="3dkl42adk71jf" />
          </div>
          <div id="how-it-works" data-id="element-14" data-mp="3dlnwimqj5c1g">
            <HowItWorks data-id="element-15" data-mp="3dii530ufhy2k" />
          </div>
          <div id="problem-proof" data-id="element-16" data-mp="nwc1psim5vw9">
            <ProblemProof onScrollToSection={scrollToSection} data-id="element-17" data-mp="nvar1p5ifbf2" />
          </div>
          <div id="roadmap" data-id="element-18" data-mp="stc8k5naf2of">
            <FutureRoadmap data-id="element-19" data-mp="swqaxdvybbvv" />
          </div>
          <SocialFooter data-id="element-20" data-mp="35ymodf6r9ya" />
          <StickyFooter onScrollToSection={scrollToSection} data-id="element-21" data-mp="356r32ll9c80" />
        </div>
      </div>
    </LanguageProvider>;
}